import { ReviewTemplate } from './components/review-assessment-sections/review-assessment-sections.component'

export const DO_REVIEW_TEMPLATE: ReviewTemplate = {
   reviewType: 'DO',
   sections: [
      // A. Role Engagement, Capacity & Sustainability
      {
         id: 'section_a_role_engagement_capacity',
         revieweeTitle: 'Role Engagement, Capacity & Sustainability',
         reviewerTitle: 'Role Engagement, Capacity & Sustainability',
         questions: [
            {
               id: 'capacity_to_lead_effectively',
               type: 'radio',
               required: true,
               revieweeLabel: 'Overall, my current capacity to lead effectively in the DO role feels:',
               revieweeOptions: [
                  { label: 'Strong and sustainable', value: 'strong_and_sustainable' },
                  { label: 'Generally sustainable', value: 'generally_sustainable' },
                  { label: 'Manageable with tradeoffs', value: 'manageable_with_tradeoffs' },
                  { label: 'Stretched', value: 'stretched' },
                  { label: 'At risk if unchanged', value: 'at_risk_if_unchanged' },
               ],
               reviewerLabel: 'Based on my observations, the DO’s current capacity to lead effectively in the role is:',
               reviewerOptions: [
                  { label: 'Strong and sustainable', value: 'strong_and_sustainable' },
                  { label: 'Generally sustainable', value: 'generally_sustainable' },
                  { label: 'Manageable with tradeoffs', value: 'manageable_with_tradeoffs' },
                  { label: 'Stretched', value: 'stretched' },
                  { label: 'At risk if unchanged', value: 'at_risk_if_unchanged' },
               ],
            },
            {
               id: 'workload_travel_expectations',
               type: 'radio',
               required: true,
               revieweeLabel: 'My current workload and travel expectations are:',
               revieweeOptions: [
                  { label: 'Well balanced', value: 'well_balanced' },
                  { label: 'Heavy but sustainable', value: 'heavy_but_sustainable' },
                  { label: 'Manageable short term', value: 'manageable_short_term' },
                  { label: 'Unsustainable long term', value: 'unsustainable_long_term' },
               ],
               reviewerLabel: 'The DO’s current workload and travel expectations appear:',
               reviewerOptions: [
                  { label: 'Well balanced', value: 'well_balanced' },
                  { label: 'Heavy but sustainable', value: 'heavy_but_sustainable' },
                  { label: 'Manageable short term', value: 'manageable_short_term' },
                  { label: 'Unsustainable long term', value: 'unsustainable_long_term' },
               ],
            },
            {
               id: 'sustainability_factors',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'RM staffing or experience gaps', value: 'rm_staffing_or_experience_gaps' },
                  { label: 'Volume of underperforming hospitals', value: 'volume_of_underperforming_hospitals' },
                  { label: 'Travel demands', value: 'travel_demands' },
                  { label: 'Pace of change', value: 'pace_of_change' },
                  { label: 'Role clarity / expectations', value: 'role_clarity_expectations' },
                  { label: 'Partnership and support structures', value: 'partnership_and_support_structures' },
               ],
               revieweeLabel: 'What most impacts my sustainability in this role? (Select up to 3)',
               reviewerLabel: 'Primary factors impacting the DO’s sustainability (select up to 3):',
               maxSelections: 3,
               hasOther: true,
            },
            {
               id: 'support_resources_needed',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Leadership development tools or training', value: 'leadership_development_tools_or_training' },
                  { label: 'Time and capacity for coaching', value: 'time_and_capacity_for_coaching' },
                  { label: 'Cross-hospital collaboration best practices', value: 'cross_hospital_collaboration_best_practices' },
                  { label: 'Performance management / coaching models', value: 'performance_management_coaching_models' },
                  { label: 'Financial performance tools (P&L review, budgeting, cost control)', value: 'financial_performance_tools' },
                  { label: 'Revenue growth strategies (pricing, service mix, appointment optimization)', value: 'revenue_growth_strategies' },
                  { label: 'Expense management support (labor efficiency, supply cost reduction)', value: 'expense_management_support' },
                  { label: 'Monthly KPI / scorecard tracking (margin, productivity, revenue per doctor)', value: 'monthly_kpi_scorecard_tracking' },
               ],
               revieweeLabel: 'Areas where I would like additional support or resources (Select all that apply):',
               reviewerLabel: 'Areas where additional support or resources would most benefit the DO (select all that apply):',
               hasOther: true,
            },
            {
               id: 'role_engagement_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (Optional):',
               reviewerLabel: 'Notes (optional):',
            },
         ],
      },

      // B. RM Leadership Effectiveness & Readiness
      {
         id: 'section_b_rm_leadership',
         revieweeTitle: 'RM Leadership Effectiveness & Readiness',
         reviewerTitle: 'RM Leadership Effectiveness & Readiness',
         questions: [
            {
               id: 'rm_confident_independent',
               type: 'radio',
               required: true,
               revieweeLabel: 'My Regional Managers operate as confident, independent leaders:',
               revieweeOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Inconsistently', value: 'inconsistently' },
                  { label: 'Rarely', value: 'rarely' },
               ],
               reviewerLabel: 'The DO’s Regional Managers operate as confident, independent leaders:',
               reviewerOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Inconsistently', value: 'inconsistently' },
                  { label: 'Rarely', value: 'rarely' },
               ],
            },
            {
               id: 'develops_rms_vs_steps_in',
               type: 'radio',
               required: true,
               revieweeLabel:
                  'I prioritize developing Regional Managers and empowering them to execute, rather than stepping in personally to manage the problem:',
               revieweeOptions: [
                  { label: 'Always', value: 'always' },
                  { label: 'Usually', value: 'usually' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet consistently', value: 'not_yet_consistently' },
               ],
               reviewerLabel: 'The DO prioritizes developing RMs and empowering them to execute, rather than stepping in personally:',
               reviewerOptions: [
                  { label: 'Always', value: 'always' },
                  { label: 'Usually', value: 'usually' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet consistently', value: 'not_yet_consistently' },
               ],
            },
            {
               id: 'rm_stability_continuity',
               type: 'radio',
               required: true,
               revieweeLabel: 'My leadership approach contributes to RM stability and continuity:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO’s leadership approach contributes to RM stability and continuity:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'rm_leadership_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (Optional):',
               reviewerLabel: 'Notes (optional):',
            },
         ],
      },

      // C. Hospital Leadership Stability & Support (HM/COS)
      {
         id: 'section_c_hospital_leadership_stability',
         revieweeTitle: 'Hospital Leadership Stability & Support (HM/COS)',
         reviewerTitle: 'Hospital Leadership Stability & Support (HM/COS)',
         questions: [
            {
               id: 'hm_cos_stability',
               type: 'radio',
               required: true,
               revieweeLabel: 'Hospital leadership teams (HM/COS) across my region are generally:',
               revieweeOptions: [
                  { label: 'Stable and aligned', value: 'stable_and_aligned' },
                  { label: 'Mostly stable', value: 'mostly_stable' },
                  { label: 'Mixed', value: 'mixed' },
                  { label: 'Frequently changing', value: 'frequently_changing' },
                  { label: 'At risk', value: 'at_risk' },
               ],
               reviewerLabel: 'Hospital leadership teams (HM/COS) across the DO’s region are generally:',
               reviewerOptions: [
                  { label: 'Stable and aligned', value: 'stable_and_aligned' },
                  { label: 'Mostly stable', value: 'mostly_stable' },
                  { label: 'Mixed', value: 'mixed' },
                  { label: 'Frequently changing', value: 'frequently_changing' },
                  { label: 'At risk', value: 'at_risk' },
               ],
            },
            {
               id: 'supports_rm_strengthen_partnerships',
               type: 'radio',
               required: true,
               revieweeLabel: 'I actively support RMs in strengthening HM/COS partnerships:',
               revieweeOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet', value: 'not_yet' },
               ],
               reviewerLabel: 'The DO actively supports RMs in strengthening HM/COS partnerships:',
               reviewerOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet', value: 'not_yet' },
               ],
            },
            {
               id: 'leadership_culture_issues_response',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Address early and directly', value: 'address_early_and_directly' },
                  { label: 'Coach through RMs effectively', value: 'coach_through_rms_effectively' },
                  { label: 'Escalate appropriately', value: 'escalate_appropriately' },
                  { label: 'Balance accountability with support', value: 'balance_accountability_with_support' },
               ],
               revieweeLabel: 'When leadership or culture issues arise, I: (Select all that apply)',
               reviewerLabel: 'When leadership or culture issues arise, the DO: (Select all that apply)',
            },
            {
               id: 'hospital_leadership_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (Optional):',
               reviewerLabel: 'Notes (optional):',
            },
         ],
      },

      // D. Leadership Climate & Engagement Outcomes
      {
         id: 'section_d_leadership_climate',
         revieweeTitle: 'Leadership Climate & Engagement Outcomes',
         reviewerTitle: 'Leadership Climate & Engagement Outcomes',
         questions: [
            {
               id: 'visibility_engagement_turnover',
               type: 'radio',
               required: true,
               revieweeLabel: 'I have clear visibility into engagement and turnover trends across my region:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO demonstrates clear visibility into engagement and turnover trends across the region:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'leadership_teams_feel',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear on expectations', value: 'clear_on_expectations' },
                  { label: 'Supported', value: 'supported' },
                  { label: 'Trusted', value: 'trusted' },
                  { label: 'Accountable', value: 'accountable' },
                  { label: 'Overextended', value: 'overextended' },
               ],
               revieweeLabel: 'Across my region, leadership teams generally feel: (Select up to 3)',
               reviewerLabel: 'Across the region, leadership teams generally feel (select up to 3):',
               maxSelections: 3,
            },
            {
               id: 'addresses_root_causes_through_rms',
               type: 'radio',
               required: true,
               revieweeLabel: 'Where leadership strain is present, I proactively address root causes through my RMs:',
               revieweeOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet', value: 'not_yet' },
               ],
               reviewerLabel: 'Where leadership strain is present, the DO proactively addresses root causes through RMs:',
               reviewerOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet', value: 'not_yet' },
               ],
            },
            {
               id: 'leadership_climate_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (Optional):',
               reviewerLabel: 'Notes (optional):',
            },
         ],
      },

      // E. Performance & Financial Leadership
      {
         id: 'section_e_performance_financial',
         revieweeTitle: 'Performance & Financial Leadership',
         reviewerTitle: 'Performance & Financial Leadership',
         questions: [
            {
               id: 'financial_confidence',
               type: 'radio',
               required: true,
               revieweeLabel: 'I am confident in my understanding of regional financial performance:',
               revieweeOptions: [
                  { label: 'Very confident', value: 'very_confident' },
                  { label: 'Confident', value: 'confident' },
                  { label: 'Adequate', value: 'adequate' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Limited', value: 'limited' },
               ],
               reviewerLabel: 'The DO demonstrates confidence and effectiveness in understanding regional financial performance:',
               reviewerOptions: [
                  { label: 'Very confident', value: 'very_confident' },
                  { label: 'Confident', value: 'confident' },
                  { label: 'Adequate', value: 'adequate' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Limited', value: 'limited' },
               ],
            },
            {
               id: 'coaches_rms_financial_outcomes',
               type: 'radio',
               required: true,
               revieweeLabel: 'I effectively coach RMs to understand and own financial outcomes:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO effectively coaches RMs to understand and own financial outcomes:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'balances_performance_sustainability',
               type: 'radio',
               required: true,
               revieweeLabel: 'I balance performance expectations with leadership sustainability:',
               revieweeOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet', value: 'not_yet' },
               ],
               reviewerLabel: 'The DO balances performance expectations with leadership sustainability:',
               reviewerOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet', value: 'not_yet' },
               ],
            },
            {
               id: 'performance_financial_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (Optional):',
               reviewerLabel: 'Notes (optional):',
            },
         ],
      },

      // F. Change Leadership & Execution
      {
         id: 'section_f_change_leadership',
         revieweeTitle: 'Change Leadership & Execution',
         reviewerTitle: 'Change Leadership & Execution',
         questions: [
            {
               id: 'leads_change_clarity_adoption',
               type: 'radio',
               required: true,
               revieweeLabel: 'I lead change in a way that supports clarity, adoption, and leader confidence:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO leads change in a way that supports clarity, adoption, and leader confidence:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'helps_rms_prioritize_during_change',
               type: 'radio',
               required: true,
               revieweeLabel: 'I help RMs prioritize effectively during periods of change:',
               revieweeOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet', value: 'not_yet' },
               ],
               reviewerLabel: 'The DO helps RMs prioritize effectively during periods of change:',
               reviewerOptions: [
                  { label: 'Consistently', value: 'consistently' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not yet', value: 'not_yet' },
               ],
            },
            {
               id: 'pace_of_change',
               type: 'radio',
               required: true,
               revieweeLabel: 'The current pace of change in my region feels:',
               revieweeOptions: [
                  { label: 'Healthy', value: 'healthy' },
                  { label: 'Manageable', value: 'manageable' },
                  { label: 'Heavy but doable', value: 'heavy_but_doable' },
                  { label: 'Overwhelming', value: 'overwhelming' },
                  { label: 'Unsustainable', value: 'unsustainable' },
               ],
               reviewerLabel: 'The current pace of change across the DO’s region appears:',
               reviewerOptions: [
                  { label: 'Healthy', value: 'healthy' },
                  { label: 'Manageable', value: 'manageable' },
                  { label: 'Heavy but doable', value: 'heavy_but_doable' },
                  { label: 'Overwhelming', value: 'overwhelming' },
                  { label: 'Unsustainable', value: 'unsustainable' },
               ],
            },
            {
               id: 'change_leadership_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (Optional):',
               reviewerLabel: 'Notes (optional):',
            },
         ],
      },

      // G. Communication & Partnership
      {
         id: 'section_g_communication_partnership',
         revieweeTitle: 'Communication & Partnership',
         reviewerTitle: 'Communication & Partnership',
         questions: [
            {
               id: 'vp_partnership',
               type: 'radio',
               required: true,
               revieweeLabel: 'My partnership with the VP of Operations is:',
               revieweeOptions: [
                  { label: 'Highly aligned', value: 'highly_aligned' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Solid', value: 'solid' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs clarity', value: 'needs_clarity' },
               ],
               reviewerLabel: 'The DO’s partnership with the VP of Operations is:',
               reviewerOptions: [
                  { label: 'Highly aligned', value: 'highly_aligned' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Solid', value: 'solid' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs clarity', value: 'needs_clarity' },
               ],
            },
            {
               id: 'service_center_supports_success',
               type: 'radio',
               required: true,
               revieweeLabel: 'My partnership with the Service Center supports regional success:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO’s partnership with the Service Center supports regional success:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'communicates_risks_maintains_ownership',
               type: 'radio',
               required: true,
               revieweeLabel: 'I communicate risks, gaps, and needs while maintaining ownership:',
               revieweeOptions: [
                  { label: 'Always', value: 'always' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not consistently', value: 'not_consistently' },
               ],
               reviewerLabel: 'The DO communicates risks, gaps, and needs while maintaining ownership:',
               reviewerOptions: [
                  { label: 'Always', value: 'always' },
                  { label: 'Often', value: 'often' },
                  { label: 'Sometimes', value: 'sometimes' },
                  { label: 'Rarely', value: 'rarely' },
                  { label: 'Not consistently', value: 'not_consistently' },
               ],
            },
            {
               id: 'communication_partnership_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (Optional):',
               reviewerLabel: 'Notes (optional):',
            },
         ],
      },

      // H. Leadership Continuity, Bench Strength & Succession
      {
         id: 'section_h_leadership_continuity',
         revieweeTitle: 'Leadership Continuity, Bench Strength & Succession',
         reviewerTitle: 'Leadership Continuity, Bench Strength & Succession',
         questions: [
            {
               id: 'rm_transitions_stability',
               type: 'radio',
               required: true,
               revieweeLabel: 'During RM transitions, I provide stability and continuity:',
               revieweeOptions: [
                  { label: 'Very effectively', value: 'very_effectively' },
                  { label: 'Effectively', value: 'effectively' },
                  { label: 'Adequately', value: 'adequately' },
                  { label: 'Inconsistently', value: 'inconsistently' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
               reviewerLabel: 'During RM transitions, the DO provides stability and continuity:',
               reviewerOptions: [
                  { label: 'Very effectively', value: 'very_effectively' },
                  { label: 'Effectively', value: 'effectively' },
                  { label: 'Adequately', value: 'adequately' },
                  { label: 'Inconsistently', value: 'inconsistently' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
            },
            {
               id: 'minimizes_disruption',
               type: 'radio',
               required: true,
               revieweeLabel: 'My approach minimizes disruption to hospitals and teams:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO’s approach minimizes disruption to hospitals and teams:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'rm_bench_strength',
               type: 'radio',
               required: true,
               revieweeLabel: 'My current RM bench strength is:',
               revieweeOptions: [
                  { label: 'Strong', value: 'strong' },
                  { label: 'Moderate', value: 'moderate' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Weak / at risk', value: 'weak_at_risk' },
               ],
               reviewerLabel: 'The DO’s current RM bench strength is:',
               reviewerOptions: [
                  { label: 'Strong', value: 'strong' },
                  { label: 'Moderate', value: 'moderate' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Weak / at risk', value: 'weak_at_risk' },
               ],
            },
            {
               id: 'successor_readiness',
               type: 'radio',
               required: true,
               revieweeLabel: 'Do I have a clear successor readiness for a DO role?',
               revieweeOptions: [
                  { label: 'Yes', value: 'yes' },
                  { label: 'Somewhat', value: 'somewhat' },
                  { label: 'No', value: 'no' },
               ],
               reviewerLabel: 'The DO has clear successor readiness for a future DO role:',
               reviewerOptions: [
                  { label: 'Yes', value: 'yes' },
                  { label: 'Somewhat', value: 'somewhat' },
                  { label: 'No', value: 'no' },
               ],
            },
            {
               id: 'biggest_rm_staffing_risk',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Where is my biggest RM staffing risk today?',
               reviewerLabel: '',
            },
         ],
      },

      // I. Regional Priorities & Execution Through RMs
      {
         id: 'section_i_regional_priorities',
         revieweeTitle: 'Regional Priorities & Execution Through RMs',
         reviewerTitle: 'Regional Priorities & Execution Through RMs',
         questions: [
            {
               id: 'established_priorities_execution',
               type: 'radio',
               required: true,
               revieweeLabel: '',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO established clear regional priorities and ensured execution through RMs:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'top_3_priorities',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'My top 3 regional priorities in 2025 were:',
               reviewerLabel: '',
            },
            {
               id: 'execution_through_rms',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'How I ensured execution through RMs (follow-up, clarity, accountability, scorecards, etc.):',
               reviewerLabel: 'Evidence of execution (follow-up, accountability, scorecards, results):',
            },
         ],
      },

      // J. Standards & Initiative Adoption Across Hospitals
      {
         id: 'section_j_standards',
         revieweeTitle: 'Standards & Initiative Adoption Across Hospitals',
         reviewerTitle: 'Standards & Initiative Adoption Across Hospitals',
         questions: [
            {
               id: 'initiative_adoption_consistency',
               type: 'radio',
               required: true,
               revieweeLabel: 'I ensure consistent implementation of company initiatives, standards, and expectations across all hospitals:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO ensures consistent implementation of company initiatives, standards, and expectations across hospitals:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'hardest_initiative_why',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'What was the hardest initiative/standard to implement and why?',
               reviewerLabel: 'Hardest initiative or standard to implement and observed barriers:',
            },
         ],
      },

      // K. Underperforming Hospitals & Turnaround Ownership
      {
         id: 'section_k_underperforming',
         revieweeTitle: 'Underperforming Hospitals & Turnaround Ownership',
         reviewerTitle: 'Underperforming Hospitals & Turnaround Ownership',
         questions: [
            {
               id: 'turnaround_involvement',
               type: 'radio',
               required: true,
               revieweeLabel:
                  'I am actively involved in underperforming hospitals to ensure accountability, follow-through, and measurable improvement:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel:
                  'The DO is appropriately involved in underperforming hospitals to ensure accountability, follow-through, and measurable improvement:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'turnaround_root_causes',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Leadership instability', value: 'leadership_instability' },
                  { label: 'Staffing constraints', value: 'staffing_constraints' },
                  { label: 'Culture/accountability gaps', value: 'culture_accountability_gaps' },
                  { label: 'Financial underperformance', value: 'financial_underperformance' },
                  { label: 'Execution/standards inconsistency', value: 'execution_standards_inconsistency' },
               ],
               revieweeLabel: 'Where performance is still stuck, what are the primary root causes? (Select up to 3)',
               reviewerLabel: 'Primary root causes impacting stalled performance (select up to 3):',
               maxSelections: 3,
               hasOther: true,
            },
         ],
      },

      // L. COSA Partnership & Alignment
      {
         id: 'section_l_cosa_partnership',
         revieweeTitle: 'COSA Partnership & Alignment',
         reviewerTitle: 'COSA Partnership & Alignment',
         questions: [
            {
               id: 'cosa_partnership',
               type: 'radio',
               required: true,
               revieweeLabel: 'I maintain a strong partnership with COSA leaders to support stability, alignment, and execution:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO maintains a strong partnership with COSA leaders to support stability, alignment, and execution:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'reinforces_shared_expectations_hm_cos',
               type: 'radio',
               required: true,
               revieweeLabel: 'I reinforce shared leadership expectations across HMs and COSs to ensure alignment and accountability:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO reinforces shared leadership expectations across HMs and COSs:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'promotes_collaboration_best_practice_sharing',
               type: 'radio',
               required: true,
               revieweeLabel: 'I promote collaboration and information-sharing across hospitals to improve execution and performance outcomes:',
               revieweeOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
               reviewerLabel: 'The DO promotes cross-hospital collaboration and best-practice sharing:',
               reviewerOptions: [
                  { label: 'Strongly agree', value: 'strongly_agree' },
                  { label: 'Agree', value: 'agree' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Disagree', value: 'disagree' },
                  { label: 'Strongly disagree', value: 'strongly_disagree' },
               ],
            },
            {
               id: 'cosa_partnership_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (Optional):',
               reviewerLabel: 'Notes (optional):',
            },
         ],
      },

      // M. RM Development Time & Travel
      {
         id: 'section_m_rm_development_travel',
         revieweeTitle: 'RM Development Time & Travel',
         reviewerTitle: 'RM Development Time & Travel',
         questions: [
            {
               id: 'traveled_with_each_rm_twice',
               type: 'radio',
               required: true,
               revieweeLabel:
                  'In 2025, I traveled with each RM at least twice to coach, observe execution, align expectations, and support RM development:',
               revieweeOptions: [
                  { label: 'Yes', value: 'yes' },
                  { label: 'Mostly', value: 'mostly' },
                  { label: 'Some', value: 'some' },
                  { label: 'No', value: 'no' },
               ],
               reviewerLabel:
                  'The DO traveled with each RM at least twice during the year to coach, observe execution, align expectations, and support RM development:',
               reviewerOptions: [
                  { label: 'Yes', value: 'yes' },
                  { label: 'Mostly', value: 'mostly' },
                  { label: 'Some', value: 'some' },
                  { label: 'No', value: 'no' },
               ],
            },
            {
               id: 'rm_development_travel_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (Optional):',
               reviewerLabel: 'Notes (optional):',
            },
         ],
      },

      // N. Personal Leadership Reflection / Overall Leadership Impact & Development Focus
      {
         id: 'section_n_leadership_reflection',
         revieweeTitle: 'Personal Leadership Reflection',
         reviewerTitle: 'Overall Leadership Impact & Development Focus',
         questions: [
            {
               id: 'greatest_strengths',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Developing confident, independent RMs', value: 'developing_confident_independent_rms' },
                  { label: 'Building trust with leaders', value: 'building_trust_with_leaders' },
                  { label: 'Setting clear expectations and priorities', value: 'setting_clear_expectations_and_priorities' },
                  { label: 'Coaching through change and ambiguity', value: 'coaching_through_change_and_ambiguity' },
                  { label: 'Financial acumen paired with leader support', value: 'financial_acumen_paired_with_leader_support' },
                  { label: 'Strengthening HM/COS partnerships', value: 'strengthening_hm_cos_partnerships' },
                  { label: 'Calm, steady leadership during transitions', value: 'calm_steady_leadership_during_transitions' },
                  { label: 'Holding accountability while maintaining engagement', value: 'holding_accountability_while_maintaining_engagement' },
               ],
               revieweeLabel: 'My greatest strengths as a DO that support leadership stability include: (Select up to 3)',
               reviewerLabel: 'The DO’s greatest strengths supporting leadership stability (select up to 3):',
               maxSelections: 3,
               hasOther: true,
            },
            {
               id: 'leadership_focus_next_year',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'One leadership focus I want to prioritize in the next year to strengthen regional stability:',
               reviewerLabel: 'Primary leadership focus recommended for the next year:',
            },
            {
               id: 'support_adjustment_needed',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel:
                  'To remain effective and engaged in the DO role over the next 12–18 months, the most valuable support or adjustment would be:',
               reviewerLabel: 'Support, resources, or adjustments that would most enable the DO’s effectiveness over the next 12–18 months:',
            },
         ],
      },
   ],
}
